const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_advantages',
    viewClass: require('./view'),
});
